/**
 * Runtime application configuration.
 *
 * Values are resolved in order:
 * 1. window.ENV — injected at container startup via public/config.js + envsubst
 *    (values still equal to their literal "${...}" placeholder are skipped)
 * 2. process.env — baked in at build time (CRA/craco, REACT_APP_ prefix)
 */

// NOTE: window.ENV is declared globally in src/vite-env.d.ts

const isPlaceholder = (value: string | undefined): boolean =>
  value === undefined || value === '' || value.startsWith('${');

export const getRuntimeConfig = (name: string): string | undefined => {
  const runtimeValue = window.ENV?.[name];
  if (!isPlaceholder(runtimeValue)) {
    return runtimeValue;
  }

  const buildValue = process.env[name];
  if (!isPlaceholder(buildValue)) {
    return buildValue;
  }

  return undefined;
};

export interface AppConfig {
  readonly apiUrl: string | undefined;
  readonly cognitoAuthority: string | undefined;
  readonly cognitoClientId: string | undefined;
  readonly cognitoDomain: string | undefined;
}

export const APP_CONFIG: AppConfig = {
  apiUrl: getRuntimeConfig('REACT_APP_API_URL'),
  cognitoAuthority: getRuntimeConfig('REACT_APP_COGNITO_AUTHORITY'),
  cognitoClientId: getRuntimeConfig('REACT_APP_COGNITO_CLIENT_ID'),
  cognitoDomain: getRuntimeConfig('REACT_APP_COGNITO_DOMAIN'),
};
